import { render, staticRenderFns } from "./NavbarManager.vue?vue&type=template&id=07c74192&scoped=true&"
import script from "./NavbarManager.vue?vue&type=script&lang=js&"
export * from "./NavbarManager.vue?vue&type=script&lang=js&"
import style0 from "./NavbarManager.vue?vue&type=style&index=0&id=07c74192&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c74192",
  null
  
)

export default component.exports